// @ts-strict-ignore
import type {EventParams} from 'common/util/definitions-types';

import {DataDefinitionsClient} from './data-definitions-client';

class EventDefinitionsClient extends DataDefinitionsClient {
  buildEndpoint({projectId, workspaceId}) {
    return `${super.buildEndpoint({projectId, workspaceId})}/events`;
  }

  buildQueryParams({id, name, customEventId, collectEverythingEventId, useQueryCache = null}: EventParams = {}) {
    return {
      id,
      name,
      customEventId,
      collectEverythingEventId,
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
    };
  }

  buildRequestBody({eventDefinition}) {
    return JSON.stringify(eventDefinition);
  }

  processResponse(response) {
    return response.results;
  }
}

export const eventDefinitionsClient = new EventDefinitionsClient();
